module.exports = __webpack_public_path__ + "cb8f3a99c27c7af1aae00f575ad40e78.png";